import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCA8Huz7W4lW_xaqaLvyYYeRsWE1wW6XAQ",
  authDomain: "wedoit-branding.firebaseapp.com",
  databaseURL: "https://wedoit-branding-default-rtdb.firebaseio.com",
  projectId: "wedoit-branding",
  storageBucket: "wedoit-branding.firebasestorage.app",
  messagingSenderId: "294318665319",
  appId: "1:294318665319:web:aad1c8186ade7872ae2ec2",
  measurementId: "G-EZHSJPBZ7C"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
